import React from "react";

export function formatPrice(p, currency = "gbp") {
  try {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency: currency.toUpperCase() }).format(p);
  } catch {
    return `£${Number(p).toFixed(2)}`;
  }
}

export function Stat({ label, value }) {
  return (
    <div className="bg-[#0c0c0c] border border-white/10 p-6">
      <p className="text-xs uppercase tracking-[0.3em] text-white/40">{label}</p>
      <p className="font-serif text-4xl mt-3">{value}</p>
    </div>
  );
}
